import { styled } from '@linaria/react';

export const Skeleton = styled.div`
  background-color: var(--bb-skeleton-bg);
  animation: pulse 1.5s ease-in-out 0.5s infinite;
  width: 100%;
  max-width: ${({ width }) => (width ? width : '100%')};
  flex-shrink: 0;
  border-radius: ${({ radius }) => (radius ? radius : '8px')};
  height: ${({ height }) => (height ? height : '100%')};
`;

export const SkeletonBase = styled.div`
  background-color: var(--bb-skeleton-bg);
  animation: pulse 1.5s ease-in-out 0.5s infinite;
  margin: 0;
  padding: 0;
  border-radius: var(--bb-global-border-radius);
`;
